import {UserInputType} from '../../../../constants/stores';
import {RootStore} from '../../stores/RootStore';
import {ValidationResult} from '../../../../types/type';

export const getQuantityValidation = (rootStore: RootStore): ValidationResult => {
  const {maxQuantity, minQuantity, userInputErrors, quantityInput} = rootStore.$state;
  const isError = userInputErrors[UserInputType.Quantity][0];
  return {
    isError,
    errorMessage:
      quantityInput > maxQuantity
        ? rootStore.t.productPage.quantityWidget.errorMessage.exceedsInventory({
            inventory: maxQuantity,
          })
        : rootStore.t.productPage.quantityWidget.errorMessage.minimumQuantity({
            minQuantity,
          }),
  };
};
